module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_03_6DC79_1SD_G9F.32b3a7c9.png";